<div
  [ngStyle]="{
    left: windowWidth,
    opacity: opacityChange,
    transition: splashTransition,
  }"
  *ngIf="showSplash"
></div>
